<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import accidentAPI from "@/services/standards/accident/accidentAPI";
import medicionAusentismoAPI from "@/services/standards/medicionAusentismo/medicionAusentismoAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification";
import CheckModal from "@/components/CheckModal";
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import MedicionAusentismoPagination from "@/components/standard/medicionAusentismo/MedicionAusentismoPagination";
import Autocomplete from "@/components/standard/medicionAusentismo/Autocomplete";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import { required } from "vuelidate/lib/validators";
/**
 * Form elements component
 */
export default {
  page: {
    title: "3.3.6 Medición del ausentismo por causa médica",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Autocomplete,
    MedicionAusentismoPagination,
  },
  data() {
    return {
      submi: false,
      title: "3.3.6 Medición del ausentismo por causa médica",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "3.3.6 Medición del ausentismo por causa médica",
          active: true,
        },
      ],

      information: true,
      lista: [],
      type: [],
      typeEvent: [],
      lesion: [],
      agente: [],
      parteAfectada: [],
      subtype: [],
      listaII: [],
      code: null,
      file: null,
      lastId: 1,
      item: null,
      itemData: null,
      medicion: {
        start_date: null,
        final_date: null,
        inability_type: null,
        extension: null,
        days_disability: null,
        file: null,
        diagnostic_code_id: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,
      select: null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      usersList: [],
      company: this.$store.getters["company/getCompany"] || null,
      exist: false,
      cantidad: false,
      search: "",
      search2: "",
      loading: true,
    };
  },

  validations: {
    file: {
      required,
    },

    search2: {
      required,
    },

    medicion: {
      start_date: {
        required,
      },
      final_date: {
        required,
      },
      inability_type: {
        required,
      },

      employee_id: {
        required,
      },
    },
  },
  methods: {
    handleOptionSelected(option) {
      this.medicion.diagnostic_code_id = option.id
    },

    fetch() {
      // this.loading = true;
      this.$refs.paginator.query();
    },

    getItem() {
      CompanyItemsAPI.getStatus(this.companyID, 40)
        .then((response) => {
          this.exist = response.id;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAccidents() {
      accidentAPI
        .getAllAccidents(this.companyID)
        .then((response) => {
          this.cantidad = response.Accident_report;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItemData() {
      ItemAPI.getItems(40)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page;
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 40)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.3.6/ausentismo/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/3.3.6/ausentismo/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.medicion.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getType() {
      accidentAPI
        .getType()
        .then((response) => {
          this.type = response.Accident_report_type;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getSubType() {
      accidentAPI
        .getType()
        .then((response) => {
          let typeAccident = response.Accident_report_type;
          this.type = typeAccident;
          this.subtype = typeAccident[0].report_subtype;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getTypeEvent() {
      accidentAPI
        .getTypeEvent()
        .then((response) => {
          this.typeEvent = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gettypeOfInjury() {
      accidentAPI
        .gettypeOfInjury()
        .then((response) => {
          this.lesion = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAccidentAgent() {
      accidentAPI
        .getAccidentAgent()
        .then((response) => {
          this.agente = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getInjuredPartBody() {
      accidentAPI
        .getInjuredPartBody()
        .then((response) => {
          this.parteAfectada = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      medicionAusentismoAPI
        .getAll(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.lista = response.data.data;
          if (response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }
          this.loading = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async save2() {
      if (this.medicion.inability_type === '' || this.medicion.inability_type === null || this.medicion.inability_type === undefined) {
        setTimeout(() => {
          Swal.fire({
            title: "¡Alerta!",
            text: "¡El campo tipo de enfermedad es obligatorio!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 500)
      } else {
        this.submitted = true;
        this.loading = false
        let response = await this.uploadDocument();
        if (response) {
          medicionAusentismoAPI.save(this.medicion)
            .then((response) => {
              const itemChange = {
                companies_id: this.companyID,
                item_id: 40,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  this.sendNotification(30, 40, true);
                  this.sendNotification(32, 40, true);
                  this.loading = true
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Se ha registrado con éxito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 2000)
                })
                .catch((error) => {
                  this.loading = true
                  setTimeout(() => {
                    Swal.fire({
                      title: "Error",
                      text: "¡No se ha podido registrar!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1000);
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.loading = true
          setTimeout(() => {
            Swal.fire({
              title: "¡Errorr!",
              text: "¡No se ha podido registrar!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }, 2000)
        }
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },
  },

  mounted() {
    this.getUsers();
    this.getItems();
    this.getItem();
    this.getList();
    this.getItemData();
    this.getAccidents();
    this.getType();
    this.getSubType();
    this.getTypeEvent();
    this.gettypeOfInjury();
    this.getAccidentAgent();
    this.getInjuredPartBody();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Este indicador mide la pérdida de días programados de trabajo en el mes por incapacidad médica.
                    </p>
                    <p class="text-justify">
                      Los días programados de trabajo al mes corresponden a la cantidad de días laborales en el mes por
                      el número de trabajadores.
                    </p>
                    <p class="text-justify">
                      El responsable de la implementación deberá definir la meta mensual y anual, además el responsable
                      de la medición y las personas que deben conocer el resultado.
                    </p>
                  </CheckModal>
                </div>

              </div>

              <div class="form-group text-right m-b-0">
                <button @click="
                  goPage(
                    `/forms/estandares/${companyID}/dias-laborales`
                  )
                  " class="btn btn-primary mx-1">
                  <span class="btn-label">Configuracion de dias laborales</span>
                </button>

              </div>

              <form :disabled="!getRole('Crear') || !allowAccess()" class="form-group" @submit.prevent="save2">
                <div>
                  <div class="form-row pt-3 px-3">
                    <b-form-group class="col-md-6" label="Colaborador" label-for="employee">
                      <select :disabled="!allowAccess() || !getRole('Crear')" required id="employeeID"
                        class="form-control" v-model="medicion.employee_id">
                        <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                          {{ item.full_name }}
                        </b-form-select-option>
                      </select>
                    </b-form-group>

                    <b-form-group label="Tipo de enfermedad" required label-for="tipo" inline class="col-sm-6 pl-4">
                      <div>
                        <label class="mr-2 mt-1"> Accidente de trabajo </label>
                        <input :disabled="!getRole('Crear') || !allowAccess()" type="radio" style="color: #666"
                          value="Accidente_de_trabajo" v-model="medicion.inability_type"
                          class="mb-2 mr-sm-2 mb-sm-0 mt-1" label="accidente" />
                        <label class="mr-2 pl-sm-2 pl-md-0 mt-1">
                          Enfermedad general
                        </label>
                        <input :disabled="!getRole('Crear') || !allowAccess()" type="radio" value="Enfermedad_general"
                          v-model="medicion.inability_type" class="mb-2 mr-sm-2 mb-sm-0" label="incidente" />
                        <label class="mr-2 pl-sm-2 pl-md-0 mt-1">
                          Enfermedad laboral
                        </label>
                        <input :disabled="!getRole('Crear') || !allowAccess()" type="radio" value="Enfermedad_laboral"
                          v-model="medicion.inability_type" class="mb-2 mr-sm-2 mb-sm-0 mt-1" label="enfermedad" />
                      </div>
                    </b-form-group>
                  </div>

                  <div class="form-row pt-3 px-3">
                    <b-form-group class="col-md-6" label="Fecha inicio" label-for="trainingDate">
                      <b-form-input required :disabled="!allowAccess() || !getRole('Crear')" type="date"
                        id="trainingDate" v-model="medicion.start_date">
                        >
                      </b-form-input>
                    </b-form-group>

                    <b-form-group class="col-md-6" label="Fecha fin" label-for="trainingDate">
                      <b-form-input required :disabled="!allowAccess() || !getRole('Crear')" type="date"
                        id="trainingDate" v-model="medicion.final_date">
                        >
                      </b-form-input>
                    </b-form-group>
                  </div>

                  <div class="form-row pt-3 px-3">
                    <b-form-group class="col-md-3" label="Código diagnóstico" label-for="input-sm">
                      <Autocomplete @option-selected="handleOptionSelected" v-model="search2" required />
                    </b-form-group>

                    <b-form-group class="col-md-3" label="Días de incapacidad" label-for="input-sm">
                      <b-form-input required type="number" maxlength="100"
                        :disabled="!getRole('Crear') || !allowAccess()" id="textarea" v-model="medicion.days_disability"
                        rows="4"></b-form-input>
                    </b-form-group>

                    <b-form-group label="Prórroga" label-for="¿Evaluada el ultimo año?" inline
                      class="col-md-6 pl-5 pt-2">
                      <label class="mr-2"> Si </label>
                      <input type="radio" style="color: #666" value="SI" v-model="medicion.extension"
                        class="mb-2 mr-sm-2 mb-sm-0" label="accidente" />
                      <label class="mr-2 pl-sm-2 pl-md-0"> No </label>
                      <input type="radio" value="NO" class="mb-2 mr-sm-2 mb-sm-0" label="incidente"
                        v-model="medicion.extension" />
                    </b-form-group>
                  </div>

                  <div class="form-row px-3">
                    <b-form-group class="col-md-12" label="Subir archivo" label-for="file">
                      <b-form-file required :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file"
                        ref="file" name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                        drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                        accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                        >
                      </b-form-file>
                    </b-form-group>
                  </div>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />
                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <div class="form-row row text-center">
                            <form @submit.prevent="fetch()" class="form-inline">
                              <div class="col-sm-11 col-md-5">
                                <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                  class="form-control px-2" placeholder="Buscar"></b-form-input>
                              </div>
                              <div class="col-sm-1 pl-5">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">
                                Fecha inicio
                              </th>
                              <th class="text-center align-middle">
                                Fecha fin
                              </th>
                              <th class="text-center align-middle">
                                Colaborador
                              </th>
                              <th class="text-center align-middle">Tipo</th>
                              <th class="text-center align-middle">
                                Dias incapacidad
                              </th>
                              <th class="text-center align-middle">
                                Diagnóstico
                              </th>
                              <th class="text-center align-middle">Prórroga</th>
                              <th class="text-center align-middle">
                                Ver archivo
                              </th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dato.start_date }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.final_date }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.full_name }}
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.inability_type ===
                                  'Accidente_de_trabajo'
                                ">
                                  Accidente de trabajo
                                </div>
                                <div v-if="dato.inability_type === 'Enfermedad_general'
                                ">
                                  Enfermedad general
                                </div>
                                <div v-if="dato.inability_type === 'Enfermedad_laboral'
                                ">
                                  Enfermedad laboral
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                {{ dato.days_disability }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.description4_codes }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.extension }}
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.file === null">
                                  <h6>No hay archivo disponible</h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()" style="
                                      background-color: transparent !important;
                                      border: none;
                                    " type="button" @click="gotoDigitalOcean(`${dato.file}`)">
                                    <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " :to="{
                                        path: `/forms/estandares/medicion-ausentismo-ver/${dato.id}`,
                                      }">
                                      Ver</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " v-b-modal="`modal${dato.id}`">Editar</b-dropdown-item>

                                    <b-modal :id="`modal${dato.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                      <div class="text-justify">
                                        <h4 class="mt-2 text-primary text-center">
                                          Advertencia
                                        </h4>
                                        <p class="mt-3">
                                          Al modificar esta información se
                                          quitará el puntaje correspondiente a
                                          este ítem y será necesario realizar
                                          nuevamente la validación por parte del
                                          usuario responsable de Emisión.
                                        </p>
                                        <button :disabled="!getRole('Editar') || !allowAccess()
                                          " type="button" class="btn btn-primary my-2 mx-2">
                                          <router-link class="text-white" :to="{
                                            path: `/forms/estandares/medicion-ausentismo-editar/${dato.id}`,
                                          }">Editar
                                          </router-link>
                                        </button>
                                        <button type="button" @click="
                                          $bvModal.hide(`modal${dato.id}`)
                                          " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                          Cancelar
                                        </button>
                                      </div>
                                    </b-modal>

                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                      " v-on:click="deleteMedicion(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <MedicionAusentismoPagination ref="paginator" :search="search"
                          @fetch="(items) => (lista = items)" />
                      </div>
                    </div>
                  </div>
                </div>

              </form>

            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>